import {
  UpdateStateMutation,
  graphqlCall,
  updateState,
} from '@akin-home/amplify';
import { StateVariable } from '@akin-home/state-variables';
import { JSONParseSafe } from '@akin-home/utils/json';
import { StateUpdate } from './types';

export interface UpdateStateVariablesParams {
  application_id: number;

  /** User that state variables are for */
  username: string;

  updates: StateUpdate[];
}

export interface UpdateStateVariablesResponse {
  success?: boolean;
  error?: string;
  data?: {
    message: string;
    state_variables: StateVariable[];
  };
}

export const updateStateVariables = async (
  data: UpdateStateVariablesParams
) => {
  return JSONParseSafe(
    (
      await graphqlCall<UpdateStateMutation>(updateState, {
        data: JSON.stringify(data),
      })
    ).data.updateState
  ) as UpdateStateVariablesResponse;
};
